import "./dashboard-sections.css";
import { Droplets, Trash2, ShoppingBag } from "lucide-react";

const PerfRow = ({ label, value, valueColor, isLoading = false }) => (
  <div className="bd-perf-row">
    <span className="bd-perf-label">{label}</span>
    <span className="bd-perf-value" style={valueColor ? { color: valueColor } : {}}>
      {isLoading
        ? <span className="db-shimmer" style={{ height: 14, width: 60, display: "inline-block", verticalAlign: "middle" }} />
        : (value ?? "—")
      }
    </span>
  </div>
);

const SectionDivider = ({ title, icon }) => (
  <div className="lm-divider">
    {icon && <span className="lm-divider-icon">{icon}</span>}
    {title}
  </div>
);

const LossMetrics = ({ data = {}, isLoading = false }) => {

  const trashMetrics = [
    { label: "Non-Trash %",       key: "non_trash_prcnt",        color: "#25aa91" },
    { label: "Total Trash %",     key: "total_trash_prcnt",      color: "#e53935" },
    { label: "Processing Loss %", key: "processing_trash_prcnt", color: "#ee7225" },
    { label: "Sorting Loss %",    key: "sorting_trash_prcnt",    color: "#ee7225" },
  ];

  const kgTakenOffMetrics = data?.kg_taken_off_metrics ?? [];
  const trashRespData = data?.trash_metrics ?? [];
  const evpRespData = data?.evaporation_metrics ?? [];

  return (
    <div className="bd-right-col cmn_card">
      <div className="bd-perf-header">PROCESSING METRICS</div>
      {/* ── Evaporation Metrics ── */}
      <SectionDivider title="Evaporation Metrics" icon={<Droplets size={13} />} />
          <PerfRow label="% In Maturity"  value={evpRespData?.total_evaporation_prcnt ?? "0"} valueColor="#ee7225" isLoading={isLoading} />
          <PerfRow label="Assumed KG"     value={`${evpRespData?.total_evaporation_kg ?? "0"} kg`}                 isLoading={isLoading} />
          <PerfRow label="Assumed Cases"  value={evpRespData?.assumed_evaporation_cases ?? "0"}                    isLoading={isLoading} />

          {/* ── Trash ── */}
          <SectionDivider title="Trash Metrics" icon={<Trash2 size={13} />} />
          {trashMetrics.map((m, i) => (
            <PerfRow
              key={i}
              label={m.label}
              value={`${trashRespData?.[m.key] ?? "0"}%`}
              valueColor={m.color}
              isLoading={isLoading}
            />
          ))}

          {/* ── KG Taken Off ── */}
          <SectionDivider title="KG Taken Off" icon={<ShoppingBag size={13} />} />
          <PerfRow label="Total Cheeks KG" value={`${kgTakenOffMetrics?.kg_taken_off?.total_cheeks_kg ?? "0"} kg`}                isLoading={isLoading} />
          <PerfRow label="Total Strips KG" value={`${kgTakenOffMetrics?.kg_taken_off?.total_strips_kg ?? "0"} kg`}                isLoading={isLoading} />
          <PerfRow label="Total Tapita KG" value={`${kgTakenOffMetrics?.kg_taken_off?.total_tapita_kg ?? "0"} kg`}                isLoading={isLoading} />
          <PerfRow label="Total Taken Off" value={`${kgTakenOffMetrics?.kg_taken_off?.total_taken_off ?? "0"} kg`} valueColor="#1d1f2c" isLoading={isLoading} />
    </div>
  );
};

export default LossMetrics;
